import { type FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import { renderContigAttributesWidgets } from "@/app-utils/attributes-widgets.tsx";

import { useLoadDispatchWithIdAsNumber } from "../../app-utils/hooks/useLoadDispatchWithIdAsNumber.js";
import { type IContigState, shouldLoadContig } from "../../redux/modules/contig.js";
import { getClassicGenomeBrowserTracks } from "../../redux/modules/genome-browser.js";
import { type IAppState } from "../../redux/reducer.js";
import { AttributesListWidget } from "../core/navigation-panel/AttributeWidget.js";
import GenericEntityGenomeView from "../genome-viewer/GenericEntityGenomeView.js";
import { type IGenomeViewOwnProps } from "../genome-viewer/GenomeView.js";
import { TRACK_TYPE } from "../genome-viewer/new/_mod.js";

const ContigGenomeView: FC = () => {
  const { contigId } = useParams<"contigId">();
  const { contig } = useSelector<IAppState, IContigState>((state) => state.contig);
  const load = useLoadDispatchWithIdAsNumber(shouldLoadContig, contigId);

  useEffect(() => {
    void load();
  }, [load]);

  let genomeViewProps: IGenomeViewOwnProps;

  if (contig) {
    genomeViewProps = {
      title: contig.sequenceId,
      subtitle: contig.description,
      genomeId: contig.organism.id,
      contigId: contig.id,
      genomes: [contig.organism],
      range: {
        start: 1,
        stop: contig.length,
      },
      defaultTracks: getClassicGenomeBrowserTracks([TRACK_TYPE.SEQUENCE, TRACK_TYPE.GENE]),
      attributesWidgets: [
        <AttributesListWidget attributes={renderContigAttributesWidgets(contig)} key={"contig-genome-view-widget-1"} />,
      ],
    };
  }

  return <GenericEntityGenomeView genomeViewProps={genomeViewProps} loadEntityData={() => void load()} />;
};

export default ContigGenomeView;
